<template>
  <div class="exhi_live">
    <div class="title">
      <h3>{{ $t("homepage.active") }}</h3>
      <button @click="addLive">{{ $t("homepage.addactive") }}</button>
    </div>
    <el-row>
      <el-col :span="8">
        <!--        状态:-->
        {{ $t("common.status") }}:
        <el-select
          v-model="auditFlag"
          :placeholder="$t('common.select')"
          @change="initData()"
        >
          <el-option
            v-for="item in optionsLang"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="state">
      <p><span>*</span>{{ $t("common.sort") }}</p>
      <p>
        <span>{{ $t("common.statusall") }} {{ auditInfo.entire }}</span>
        <span
          >{{ $tc("common.auditstatus2", 0) }} {{ auditInfo.underReview }}</span
        >
        <span>{{ $tc("common.auditstatus2", 1) }} {{ auditInfo.audited }}</span>
        <span
          >{{ $tc("common.auditstatus2", 2) }}
          {{ auditInfo.auditNotPassed }}</span
        >
      </p>
    </div>
    <div class="box">
      <table>
        <thead>
          <tr>
            <th style="width: 113px">{{ $t('common.Number') }}</th>
            <th>{{ $t('active.activecover') }}</th>
            <th style="width: 350px">{{ $t('active.name') }}</th>
            <th style="width: 350px">{{ $t('active.type') }}</th>
            <th>{{ $t('common.startdate') }}</th>
            <th>{{ $t('common.enddate') }}</th>
            <th>{{ $t('active.location') }}</th>
            <th>{{ $t('common.status') }}</th>
            <th>{{ $t('common.operate') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tableData" :key="index">
            <td>
              <input
                type="text"
                class="inut"
                v-model="item.column13"
                @blur="inputblur(item.id, item.column13)"
              />
            </td>
            <td><img :src="imgUrl + item.column15" alt="" /></td>
            <td>{{ item.actTitle }}</td>
            <td>{{ item.activeType }}</td>
            <td>{{ item.startTime }}</td>
            <td>{{ item.endTime }}</td>
            <td>{{ item.address }}</td>
            <td>
              <template v-if="item.auditFlag == '-1'">
                <el-popover
                  placement="bottom"
                  trigger="hover"
                  :content="item.cause"
                >
                  <!--                  <span slot="reference">{{ dictory[item.auditFlag] }} </span>                  <span slot="reference">{{ dictory[item.auditFlag] }} </span>-->
                  <span slot="reference"
                    >{{ dictoryLang[item.auditFlag] }}
                  </span>
                </el-popover>
              </template>
              <template v-if="item.auditFlag != '-1'">
                <!--                {{ dictory[item.auditFlag] }}-->
                {{ dictoryLang[item.auditFlag] }}
              </template>
            </td>
            <td>
              <div class="caozuo">
                <span @click="rowEdit(item)"
                  ><i class="el-icon-edit-outline">{{
                    $t("common.edit")
                  }}</i></span
                >
                <span v-if="item.status == ''" @click="open()"
                  ><i class="el-icon-delete">{{ $t("common.submit") }}</i></span
                >
                <span @click="rowDelete(item.id)"
                  ><i class="el-icon-delete">{{ $t("common.delete") }}</i></span
                >
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="item">
        <!--分页 -->
        <div class="pagination">
          <!--          <span>共{{ totalNum }}条</span>-->
          <span>{{ $t("common.pagination", { totalNum: totalNum }) }}</span>
          <el-pagination
            class="explore_right_pages"
            layout="prev, pager, next"
            :current-page="currentPage4"
            @current-change="handleCurrentChange"
            :page-size="5"
            :total="totalNum"
          >
          </el-pagination>
        </div>
      </div>
      <div class="tips">{{ $t("active.tips") }}</div>
    </div>
  </div>
</template>

<script>
import {
  getLists,
  updateSort,
  countAudit,
  delItem,
} from "../../../../api/active.js";
import { forMat } from "../../../../utils/common.js";

export default {
  data() {
    return {
      totalNum: 1,
      dictory: {
        0: "审核通过",
        "-1": "审核不通过",
        2: "审核中",
      },
      imgUrl: forMat(),
      tableData: [],
      options: [
        {
          value: "",
          label: this.$t("common.statusall"),
        },
        {
          value: 2,
          label: this.$tc("common.auditoptions", 0),
        },
        {
          value: 0,
          label: this.$tc("common.auditoptions", 1),
        },
        {
          value: -1,
          label: this.$tc("common.auditoptions", 2),
        },
      ],
      auditFlag: "", //审核状态切换
      // 审核状态显示
      auditInfo: {},
      currentPage4: 1,
    };
  },

  components: {},

  computed: {
    //I18N双语
    optionsLang() {
      return [
        {
          value: "",
          label: this.$tc("common.statusall"),
        },
        {
          value: 2,
          label: this.$tc("common.auditoptions", 0),
        },
        {
          value: 0,
          label: this.$tc("common.auditoptions", 1),
        },
        {
          value: -1,
          label: this.$tc("common.auditoptions", 2),
        },
      ];
    },
    dictoryLang() {
      return {
        0: this.$tc("common.auditstatus", 0),
        "-1": this.$tc("common.auditstatus", 1),
        2: this.$tc("common.auditstatus", 2),
      };
    },
  },
  created() {
    this.initData("1");
    this.getCount();
  },
  methods: {
    rowDelete(id) {
      this.$confirm(
        this.$t("dialog.confirmDelete"),
        this.$t("dialog.attention"),
        {
          confirmButtonText: this.$t("dialog.sure"),
          cancelButtonText: this.$t("dialog.cancel"),
          customClass: "myClass",
        }
      )
        .then(() => {
          this.del(id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async del(id) {
      const params = {
        id,
      };

      try {
        const { data } = await delItem(params);
        if (data.code === 200) {
          // this.$message({
          //   type: 'success',
          //   message: '删除展商活动成功!',
          // });
          this.initData(this.pageNum);
          this.getCount();
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    rowEdit(item) {
      this.$router.push({ name: "add_active", query: { id: item.id } });
    },
    async getCount() {
      try {
        const { data } = await countAudit();
        if (data.code === 200) {
          this.auditInfo = data.data;
          // this.$message({
          //   type: 'success',
          //   message: '获取审核状态统计数据成功!',
          // });
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    async inputblur(id, sort) {
      const params = {
        id,
        sort,
      };
      try {
        const { data } = await updateSort(params);
        if (data.code === 200) {
          this.initData(this.pageNum);
          // this.$message({
          //   type: 'success',
          //   message: '修改排序成功!',
          // });
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    async initData(pageNum) {
      const params = {
        pageNo: pageNum,
        pageSize: "5",
        auditFlag: this.auditFlag,
      };
      try {
        const { data } = await getLists(params);
        if (data.code === 200) {
          this.tableData = data.data.list;
          this.totalNum = data.data.count;
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    //新增活动跳转路径
    addLive() {
      this.$router.push("/backIndex/add_active");
    },
    //分页发生变化
    handleCurrentChange(val) {
      this.pageNum = val;
      this.initData(this.pageNum);
    },
  },
};
</script>
<style lang="scss" scoped>
.caozuo {
  span {
    cursor: pointer;
  }
}

.tips {
  float: left;
  margin-top: 30px;
  margin-left: 26px;

  font-weight: bold;
  padding-top: 9px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  height: 36px;
}
.exhi_live {
  box-sizing: border-box;
  padding: 18px 26px 26px 0;
  background: white;

  .title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 34px;
    border-bottom: 1px solid #e9e9e9;
    padding-bottom: 17px;
    padding-left: 26px;
    h3 {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
    button {
      width: 77px;
      height: 32px;
      background: #006fb8;
      color: white;
      border-radius: 2px;
      border: none;
    }
  }
  .el-row {
    padding-left: 26px;
  }
  .state {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    font-size: 12px;
    // padding-left: 26px;
    p:first-child {
      color: red;
    }
    span {
      margin-left: 26px;
    }
  }
  .box {
    //   border: 1px solid rgb(92, 0, 221);
    // height: 650px;
    position: relative;
    table {
      margin: 15px 0px 0px 28px;
      border-collapse: collapse;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      border-radius: 3px 3px 0px 0px;
      width: 98%;
      overflow: hidden;
      thead {
        //width: 100%;
        background: #006fb8;
        border-radius: 4px 4px 0px 0px;
        tr {
          height: 36px;
          color: rgba(255, 255, 255, 0.85);
          width: 100%;
          th {
            box-sizing: border-box;
            height: 36px;
            width: 200px;
            color: white;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.85);
          }
        }
      }
      tbody {
        tr {
          height: 106px;
          border-bottom: 1px solid #e8e8e8;
          td {
            text-align: center;
            height: 106px;
            img {
              width: 104px;
              height: 78px;
              margin: 10px 0px;
            }
            span {
              color: #006fb8;
              margin: 0px 5px;
            }
            .inut {
              display: block;
              width: 35px;
              height: 24px;
              border: 1px solid #e0e0e0;
              line-height: 24px;
              color: #666666;
              margin-left: 25px;
              text-align: center;
            }
          }
          &:nth-child(even) {
            background-color: #f6f6f7;
          }
        }
      }

      .leaseCount {
        width: 100px;
        div {
          margin: 0 auto;
          text-align: center;
          width: 92px;
        }
      }
    }

    .item {
      // height: 40px;
      // background-color: skyblue;
      // position: absolute;
      right: 0px;
      bottom: 0px;
    }
    .pagination {
      // border: 1px solid red;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 15px;
      margin-top: 20px;
      span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-top: 6px;
        color: #666666;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
    margin-left: 10px;
  }
  .btn-next {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
  }
  .el-pager .number {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    margin-right: 5px;
    margin-right: 5px;
    color: #999999;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    border: none;
    cursor: pointer;
    background: #006fb8;
    color: #fff;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 28px;
    color: #999;
  }
}
</style>
